import { AVAILABILITY_FILTER_OPTIONS } from 'data/subOptions/availabilitySubOptions';
import isToday from 'date-fns/isToday';
import isTomorrow from 'date-fns/isTomorrow';
import parse from 'date-fns/parse';
import formatDate, { isValidDate } from 'utils/formatDate';

import { Translator } from '../Translator';

const methods = {
  formatCreditCard(value: string, gaps: number[]): string {
    let result = '';
    let gapIndex = 0;

    function delimeter(index) {
      if (
        index < value.length - 1 &&
        gapIndex < gaps.length &&
        gaps[gapIndex] + gapIndex === result.length
      ) {
        gapIndex += 1;
        return ' ';
      }
      return '';
    }

    value.split('').forEach((char, index) => {
      if (/\d/.test(char)) {
        result += char;
        result += delimeter(index);
      }
    });

    return result;
  },

  getPeopleText(adults: number, children: number): string {
    let translateKey = 'Common.SearchInput.people';
    if (children === 0) {
      if (adults === 1) {
        translateKey = 'Common.adult';
      } else {
        translateKey = 'Common.adults';
      }
    }
    return Translator.translate(
      translateKey,
      { amountOfPeople: adults + children },
      true,
    );
  },

  getDateText(filters) {
    const dateFromFilter = filters.activeFilters.find(
      (filter) => filter.uid === 'date.from',
    );
    const dateToFilter = filters.activeFilters.find(
      (filter) => filter.uid === 'date.to',
    );
    const availabilityFilter = filters.activeFilters.find(
      (filter) => filter.uid === 'other.availability.items[]',
    );

    if (
      availabilityFilter &&
      availabilityFilter.subOptions.find(
        (subOption) => subOption.value === AVAILABILITY_FILTER_OPTIONS.NOW,
      )
    ) {
      return Translator.translate(
        'SearchPage.DateFilter.availabilityNow',
        {},
        true,
        'Now',
      );
    }

    if (dateFromFilter && dateFromFilter.value) {
      const fromDate = parse(dateFromFilter.value, 'yyyy-MM-dd', new Date());

      if (!isValidDate(fromDate)) {
        return Translator.translate(
          'CheckoutPage.BookingDetails.date',
          {},
          true,
        );
      }

      if (dateToFilter && dateToFilter.value) {
        const toDate = parse(dateToFilter.value, 'yyyy-MM-dd', new Date());
        return (
          formatDate(fromDate, 'd MMM') + ' - ' + formatDate(toDate, 'd MMM')
        );
      }

      if (isToday(fromDate)) {
        return Translator.translate(
          'SearchPage.DateFilter.availabilityToday',
          {},
          true,
          'Today',
        );
      }

      if (isTomorrow(fromDate)) {
        return Translator.translate(
          'SearchPage.DateFilter.availabilityTomorrow',
          {},
          true,
          'Tomorrow',
        );
      }

      return formatDate(fromDate, 'd MMM');
    }
    return Translator.translate('CheckoutPage.BookingDetails.date', {}, true);
  },
};

export default methods;
